<template>
  <van-popup
    class="address-popup"
    position="bottom"
    v-bind="$attrs"
    :style="{ height: '80%' }"
    v-on="$listeners"
  >
    <div class="address-popup-header">配送至</div>
    <div class="address-list">
      <van-address-list
        v-model="currentAddressId"
        :list="formatAddressList"
        default-tag-text="默认"
        @select="
          $nextTick(() => {
            $emit('select',currentAddressObj)
            $emit('input', false)
          })
        "
        @add="$router.push('/address/create')"
        @edit="$router.push({ name: 'editAddress', params: { id: $event.id } })"
      >
        <van-empty v-if="formatAddressList.length === 0" description="暂无地址" />
      </van-address-list>
    </div>
  </van-popup>
</template>

<script>
export default {
  name: 'AddressPopup',
  components: {

  },
  props: {
    addressId: {
      type: String,
      default: ''
    },
    addressList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {

    }
  },
  computed: {
    currentAddressId: {
      get() {
        return this.addressId
      },
      set(value) {
        this.$emit('update:address-id', value)
      }
    },
    currentAddressObj() {
      let item = {}
      for (let i = 0; i < this.formatAddressList.length; i++) {
        if (this.formatAddressList[i].id === this.currentAddressId) {
          item = this.formatAddressList[i]
          break
        }
      }
      return item
    },
    formatAddressList() {
      return this.addressList.map(item => {
        return {
          ...item,
          name: item.userName,
          tel: item.mobile,
          address: `${item.province || ''}${item.city || ''}${item.county || ''}${item.town || ''}${item.deliverAddress || ''}`
        }
      })
    }
  },
  mounted() {

  },
  methods: {

  }
}
</script>

<style scoped lang="scss">
// scss
.address-popup {
  .address-popup-header {
    height: 44px;
    text-align: center;
    line-height: 44px;
    font-weight: 600;
    border-bottom: 1px solid #eee;
    position: sticky;
    top: 0;
    z-index: 10;
    background-color: #fff;
  }
  .address-list {
    min-height: calc(100% - 50px);
    background-color: $background-default-color;
    .van-address-item {
      border-radius: 4px;
      .van-tag--danger {
        background-color: $color-primary;
      }
    }
    .van-button--danger {
      background-color: $color-primary;
      border-color: $color-primary;
    }
  }
}
</style>
